// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3YTaV","list":"BalanceDue_list__8B_v0","listRow":"BalanceDue_listRow__OBrg9","total":"BalanceDue_total__1zfkW"};